import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {ZakljucakIzvrsiteljaDocument} from "./ZakljucakIzvrsiteljaDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga
export const zakljucakIzvrsiteljaDocumentFields: IntercateKeysMap<ZakljucakIzvrsiteljaDocument, EntityField<ZakljucakIzvrsiteljaDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<ZakljucakIzvrsiteljaDocument>> = [
	zakljucakIzvrsiteljaDocumentFields.indexingNumber,
	zakljucakIzvrsiteljaDocumentFields.indexingDate,
	zakljucakIzvrsiteljaDocumentFields.documentNumber,
	zakljucakIzvrsiteljaDocumentFields.documentDate,
	zakljucakIzvrsiteljaDocumentFields.assignedTo,
	zakljucakIzvrsiteljaDocumentFields.clientId,
	zakljucakIzvrsiteljaDocumentFields.sectorId,
	zakljucakIzvrsiteljaDocumentFields.tags,
	zakljucakIzvrsiteljaDocumentFields.description,
	zakljucakIzvrsiteljaDocumentFields.parentId
]

export const zakljucakIzvrsiteljaDocumentFieldsDescriptor: EntityFieldsDescriptor<ZakljucakIzvrsiteljaDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
